import { createFileRoute } from '@tanstack/react-router';
import { ResetPasswordPage } from '@pages/reset-password';
import { PageTransition } from '@ui';

export const Route = createFileRoute('/r')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      t: (search.t as string) || (search.token as string) || '',
    };
  },
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  return (
    <PageTransition>
      <ResetPasswordPage />
    </PageTransition>
  );
}
